var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4402 3.83721H17.9737C19.3249 3.83721 20.4203 4.93259 20.4203 6.28381V9.6628M6 15H12M6 17.2521H10.8451M6 12.6545H8.52522M17.8544 21H6.14563C4.40835 21 3 19.5917 3 17.8544V6.14563C3 4.40835 4.40835 3 6.14563 3H9.67851C10.5616 3 11.3647 3.51176 11.7377 4.31221L13.2233 8.33721H17.8544C19.5917 8.33721 21 9.74556 21 11.4828V17.8544C21 19.5917 19.5917 21 17.8544 21Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubject);
export default __webpack_public_path__ + "static/media/subject.593322cc6cf9ef28ec5eb9e703dd23c1.svg";
export { ForwardRef as ReactComponent };